import {
  BatchOperation,
  CardList,
  DeleteModal,
  FilterForm,
  IconFont,
  ListPage,
  PageContainer,
  SearchInput,
  SignTitle,
  SvgIcon,
  TableTag,
} from '@/components'
import {
  Card,
  Button,
  Form,
  Checkbox,
  Pagination,
  Spin,
  Typography,
  Empty,
  Dropdown,
  Space,
  Menu,
  Input,
  Row,
  Col,
  Select,
  Divider,
} from 'antd'
import { SyncOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDeleteTask, useEndTask, useGetTaskList } from './utils'
import { useMemo, useState } from 'react'
import { GetTaskListData } from '@/api/fishing-task'
import { useDebounceFn, useSelections } from 'ahooks'
import { useUpStart } from '../task-detail/utils'
import { ShowTotal } from '@/components/show-total'
import Scrollbar from 'react-custom-scrollbars'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { AdvancedPopover, DTOption } from '@/components/advanced-search'
import { CreateReport } from '@/components/create-report'
import { useAddReport } from '@/pages/evaluation/report-task/utils'
import type { MenuProps } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { t } from '@/i18n'
const { useForm } = Form

export interface DeleteTaskModal {
  id?: string[]
  visibel: boolean
}

export interface EndTaskModal {
  id?: string
  visibel: boolean
}
const Activity = () => {
  const [createForm] = useForm()
  // const [element, setElement] = useState<HTMLDivElement | null>(null)
  const { state }: any = useLocation()
  const navigate = useNavigate()
  const [getTaskListParams, setGetTaskListParams] = useState<GetTaskListData>({
    limit: 10,
    page: 1,
    ...state,
  })
  const [deleteTaskModal, setDeleteTaskModal] = useState<DeleteTaskModal>({
    visibel: false,
  })
  const [endTaskModal, setEndTaskModal] = useState<EndTaskModal>({
    visibel: false,
  })
  interface TaskList {
    campaign_id: number
    task_name: string
  }
  const [addReport, setAddReport] = useState({
    visible: false,
    result_id: null,
    name: null,
    multiple: false,
    selectItem: [],
    task_list: [] as TaskList[],
  })
  const [selectOptions, setSelectOptions] = useState([])
  const [totalList, setTotalList] = useState<any>([])
  const [endTask, endTaskLoading] = useEndTask()
  const [upStart, upTaskLoading] = useUpStart()
  const [taskList, taskListLoading, getTaskList] = useGetTaskList({
    getTaskListData: getTaskListParams,
  })
  const { run: searchTask } = useDebounceFn(
    (name: string) => {
      setGetTaskListParams(origin => ({ ...origin, page: 1, name }))
    },
    {
      wait: 300,
    },
  )
  const [deleteTask, deleteTaskLoading] = useDeleteTask()

  const deleteTaskHandler = async () => {
    try {
      await deleteTask({ id: deleteTaskModal.id })
      unSelectAll()
      setGetTaskListParams(origin => ({ ...origin, page: 1 }))
      setDeleteTaskModal({ visibel: false })
      setSelectedKeys([])
    } catch (error) {}
  }

  const endTaskHandler = (id: string) => () => {
    setEndTaskModal({ visibel: true, id })
  }

  const endTaskConfirmHandler = async () => {
    if (!endTaskModal.id) return
    try {
      await endTask({ id: endTaskModal.id })
      getTaskList()
      setEndTaskModal({ visibel: false })
    } catch (error) {}
  }
  const upTaskHandler = (id: string) => async () => {
    if (endTaskLoading) return
    try {
      await upStart({ id })
      getTaskList()
    } catch (error) {}
  }

  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([])
  const [generateReport, createLoading] = useAddReport()
  const confirmAddGroup = value => {
    let taskData = []
    if (addReport.multiple) {
      taskData = value.campaign_ids.reduce((acc, id) => {
        const item = addReport.selectItem.find(i => i.id === id)
        if (item) {
          acc.push({ task_name: item.task_name, campaign_id: item.id })
        }
        return acc
      }, [])
    } else {
      taskData = addReport.task_list
    }
    generateReport({
      task_list: taskData,
      report_name: value.report_name,
      template_type:
        addReport?.multiple && addReport?.selectItem?.length > 1 ? [2] : value.template_type,
      campaign_type: value.campaign_type,
      emails: '',
      assets: 0,
    })
      .then(() => {
        window.open('/report/task/task-report?tab=1', '_self')
      })
      .catch(_ => {})
  }
  let option = {
    name: {
      type: 'input',
      label: t('任务名称'),
    },
    email_type: {
      type: 'radio',
      label: t('模板类型'),
      data: [
        { name: t('钓鱼链接'), id: '1' },
        { name: t('恶意附件'), id: '2' },
      ],
    },
    score: {
      type: 'radio',
      label: t('评分'),
      data: [
        { name: t('优秀'), id: '1' },
        { name: t('良好'), id: '2' },
        { name: t('较差'), id: '3' },
        { name: t('差'), id: '4' },
      ],
    },
    status: {
      type: 'radio',
      label: t('任务状态'),
      data: [
        { name: t('已预订'), id: '1' },
        { name: t('进行中'), id: '2' },
        { name: t('已完成'), id: '3' },
        { name: t('异常'), id: '4' },
      ],
    },
  }

  const selectId = useMemo(() => {
    let arr = []
    let arrList = []
    if (taskList?.items?.length > 0) {
      arr = taskList?.items?.map(item => item.id)
      for (const el of taskList.items) {
        arrList.push(el)
      }
    }
    setTotalList(
      Array.from(
        new Map(
          totalList
            .concat(arrList)
            .filter(i => typeof i === 'object')
            .map(item => [item.id, { ...item }]),
        ).values(),
      ),
    )
    return arr
  }, [taskList?.items])

  const { selected, allSelected, isSelected, toggle, toggleAll, unSelectAll } =
    useSelections(selectId)

  return (
    <PageContainer>
      <TaskListContainer
        title={<SignTitle>{t('任务列表')}</SignTitle>}
        actions={[
          taskList?.items?.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 20 }}>
              <Pagination
                current={getTaskListParams.page}
                pageSize={getTaskListParams.limit}
                total={taskList.total}
                showTotal={total => <ShowTotal>{total}</ShowTotal>}
                showSizeChanger
                showQuickJumper
                onChange={(page, pageSize) => {
                  setGetTaskListParams(origin => ({ ...origin, page, limit: pageSize as number }))
                }}
              />
            </div>
          ),
        ]}
      >
        <Task>
          <FilterForm
            option={option}
            setSearchParams={setGetTaskListParams}
            onReset={() => {
              setGetTaskListParams({
                page: 1,
                limit: 10,
              })
            }}
          />

          <div style={{ padding: '0 20px' }}>
            {' '}
            {!(selected?.length > 0) ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: 10,
                  paddingLeft: 20,
                }}
              >
                <Checkbox
                  indeterminate={!allSelected && selected.length > 0}
                  checked={allSelected}
                  onChange={() => {
                    toggleAll()
                  }}
                >
                  {`${t('全选')}（${t('已选')} ${selected.length} ${t('项')}）`}
                </Checkbox>
                <RefreshButton
                  // className="refreshButton"
                  icon={<SyncOutlined />}
                  onClick={() => {
                    getTaskList()
                  }}
                />
              </div>
            ) : (
              <BatchOperation
                selectedRowKeys={selected}
                batchOperation={
                  <Space split={<Divider type={'vertical'} />}>
                    <Checkbox
                      indeterminate={!allSelected && selected.length > 0}
                      checked={allSelected}
                      onChange={() => {
                        toggleAll()
                      }}
                    >
                      {`${t('全选')}（${t('已选')} ${selected.length} ${t('项')}）`}
                    </Checkbox>
                    <Delete
                      onClick={() => {
                        if (selected?.length > 0) {
                          setDeleteTaskModal({ visibel: true, id: selected as string[] })
                        }
                      }}
                      isActive={selected?.length > 0}
                    >
                      <SvgIcon
                        name={selected?.length > 0 ? 'batch_remove' : 'batch_remove_ash'}
                        className="icon-delete"
                      />

                      <span>{t('批量删除')}</span>
                    </Delete>
                    <Export
                      length={selected.length}
                      onClick={() => {
                        if (selected?.length > 0 && selected?.length <= 5) {
                          const uniqueSelectItem = [
                            ...new Map(
                              totalList
                                .filter(i => typeof i === 'object' && selected.includes(i.id))
                                .map(item => [
                                  item.id,
                                  { task_name: item.name, result_status: item.status, ...item },
                                ]),
                            ).values(),
                          ]

                          setAddReport({
                            visible: true,
                            result_id: null,
                            name: null,
                            multiple: true,
                            selectItem: uniqueSelectItem,
                            selected,
                          })
                        }
                      }}
                      active={selected?.length > 0}
                    >
                      <SvgIcon
                        name={selected?.length > 0 ? '批量生成报表' : 'batch_remove_ash'}
                        className="icon-export"
                      />

                      <span>{t('批量生成报表')}</span>
                    </Export>
                  </Space>
                }
                setSelectedRowKeys={unSelectAll}
              />
            )}
          </div>
          <CreateReport
            visible={addReport.visible}
            multiple={addReport.multiple}
            selectItem={addReport.selectItem}
            createLoading={createLoading}
            templateType={1}
            onConfirm={e => {
              confirmAddGroup(e)
            }}
            onCancel={() => {
              setAddReport({
                visible: false,
                result_id: null,
                name: null,
                multiple: false,
                selectItem: [],
                task_list: [],
              })
            }}
          />

          <div style={{ height: 'calc(100% - 80px)', padding: '0 20px' }}>
            <Scrollbar>
              {!taskListLoading ? (
                // <div style={{ paddingRight: 10 }}>
                <div>
                  {taskList.items?.map(item => (
                    <CardList
                      background={item.type === '恶意附件' ? '#D0011C' : '#645AFF'}
                      key={item.id}
                    >
                      <TaskListMain>
                        <Checkbox
                          checked={isSelected(item.id)}
                          onChange={() => {
                            toggle(item.id)
                            setSelectOptions(Array.from(new Set([...selectOptions, item])))
                          }}
                        />

                        <div
                          className="flex1"
                          style={{ marginLeft: 24, width: '20%', paddingRight: '50px' }}
                        >
                          <div className="flex">
                            <TableTag
                              background={item.type === '恶意附件' ? '#F5D9DA' : '#EBE9FF'}
                              color={item.type === '恶意附件' ? '#D0011C' : '#645AFF'}
                            >
                              {item.type}
                            </TableTag>
                            <Typography.Text
                              style={{
                                marginLeft: 10,
                                width: 'calc(100% - 100px)',
                                fontWeight: 600,
                              }}
                              ellipsis={{ tooltip: true }}
                            >
                              {item.name}
                            </Typography.Text>
                          </div>
                          <div style={{ marginTop: 14 }}>
                            {t('创建时间：')}
                            {item.create_time}
                          </div>
                        </div>
                        <div className="flex1">
                          <div className="flex">
                            <div>{t('评分：')}</div>
                            <Progress percent={item.score} />
                            <div style={{ marginLeft: 10 }}>
                              {item.score}/
                              {(item.score >= 80 && t('优秀')) ||
                                (item.score >= 60 && t('良好')) ||
                                (item.score >= 40 && t('较差')) ||
                                (item.score < 40 && t('差'))}
                            </div>
                          </div>
                        </div>
                        <div className="flex1">
                          {t('开始时间：')}
                          {item.start_time}
                        </div>
                        <div className="flex1">
                          {t('结束时间：')}
                          {item.end_time}
                        </div>
                        <div style={{ width: 100 }}>
                          {item.status === '1' ? (
                            <TableTag background="#FFEFD7" color="#FFAD31" borderRadius={4}>
                              {t('已预订')}
                            </TableTag>
                          ) : item.status === '2' ? (
                            <TableTag color="#2973FF" background="#E9F1FF" borderRadius={4}>
                              {t('进行中')}
                            </TableTag>
                          ) : item.status === '3' ? (
                            <TableTag color="#67C23A" background="#F2F9EB" borderRadius={4}>
                              {t('已完成')}
                            </TableTag>
                          ) : (
                            <TableTag color="#F53F3F" background="#FFDCE0" borderRadius={4}>
                              {t('异常')}
                            </TableTag>
                          )}
                        </div>
                        <div className="flex-end">
                          {item.status === '1' && (
                            <div className="flex pointer" onClick={upTaskHandler(item.id)}>
                              <Icon type="icon-kaishirenwu" />
                              <div className="operate-text" style={{ width: 'auto' }}>
                                {t('立即开始')}
                              </div>
                              <div className="branching" />
                            </div>
                          )}
                          {item.status === '2' && (
                            <div className="flex pointer" onClick={endTaskHandler(item.id)}>
                              <Icon type="icon-shengchandacheng-" />
                              <div className="operate-text">{t('结束任务')}</div>
                              <div className="branching" />
                            </div>
                          )}

                          {
                            <a
                              href={`/validation/awareness/phishing?tab=task&name=detail&id=${item.id}`}
                              target="_blank"
                              className="flex pointer"
                              style={{ textDecoration: 'none' }}
                            >
                              <Icon type="icon-chakan" />
                              <div className="operate-text">{t('查看')}</div>
                            </a>
                          }
                          {item.status !== '4' && <div className="branching" />}
                          {
                            <Dropdown
                              trigger={['click']}
                              overlay={
                                <Menu
                                  items={[
                                    {
                                      key: '1',
                                      // icon: <Icon type="icon-tuijianbaobiao" />,
                                      label: (
                                        <div
                                          className="operate "
                                          // className={
                                          //   item.status !== '3' ? 'operate' : 'operate pointer'
                                          // }
                                          onClick={() => {
                                            console.log('item', item)
                                            if (item.status !== '3') return false
                                            // setStatement({ visible: true, item: item })
                                            setAddReport({
                                              result_id: item.id,
                                              visible: true,
                                              name: item.task_name,
                                              multiple: false,
                                              selectItem: [],
                                              task_list: [
                                                { task_name: item.name, campaign_id: item.id },
                                              ],
                                            })
                                          }}
                                        >
                                          <IconFont type="icon-tuijianbaobiao" />
                                          <div
                                            className={item.status !== '3' ? 'operate-active' : ''}
                                          >
                                            {t('生成报表')}
                                          </div>
                                        </div>
                                      ),

                                      // icon: <Icon type="icon-tuijianbaobiao" />,
                                      disabled: item.status !== '3',
                                    },
                                    {
                                      key: '2',
                                      label: (
                                        <div
                                          className="operate "
                                          onClick={() => {
                                            setDeleteTaskModal({ visibel: true, id: [item.id] })
                                          }}
                                        >
                                          <Icon type="icon-shanchu-m" />
                                          <div className="">{t('删除任务')}</div>
                                        </div>
                                      ),

                                      // icon: <Icon type="icon-shanchu-m" />,
                                    },
                                  ]}
                                />
                              }
                            >
                              <div style={{ color: '#4238C9' }}>
                                <Space size={4}>
                                  {t('更多')}
                                  <DownOutlined />
                                </Space>
                              </div>
                            </Dropdown>
                          }
                        </div>
                      </TaskListMain>
                    </CardList>
                  )) || <Empty image={EmptyImg} />}
                </div>
              ) : (
                <div style={{ height: 'calc(100% - 40px' }}>
                  <Spin />
                </div>
              )}
            </Scrollbar>
          </div>
        </Task>
      </TaskListContainer>
      <DeleteModal
        onOk={deleteTaskHandler}
        visible={deleteTaskModal.visibel}
        title={<SignTitle show>{t('提示')}</SignTitle>}
        text={t('此操作将永久删除该任务,是否继续?')}
        confirmLoading={deleteTaskLoading}
        onCancel={() => {
          setDeleteTaskModal({ visibel: false })
        }}
      />
      <DeleteModal
        onOk={endTaskConfirmHandler}
        visible={endTaskModal.visibel}
        title={<SignTitle show>提示</SignTitle>}
        text="停止任务后事件将不再被记录，请确认是否立即停止任务？"
        confirmLoading={endTaskLoading}
        onCancel={() => {
          setEndTaskModal({ visibel: false })
        }}
      />
    </PageContainer>
  )
}

export default Activity
const TaskListContainer = styled(Card)`
  min-height: 100%;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .ant-table-thead > tr > th {
    font-weight: 600;
  }
  .ant-table {
    margin-bottom: 24px;
  }
  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: rgba(0, 0, 0, 0.03) !important;
  }
  .ant-popover-title {
    height: 50px;
    display: flex;
    align-items: center;
  }
  .ant-card-body {
    padding: 20px 0;
  }
  .search-button {
    background: #f1f3f8;
    border-radius: 6px;
    padding: 9px 18px;
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      color: #0b0a27;
      background: #e2e4f6;
    }
  }
  .bottom {
    padding: 0 20px;
  }
`
interface GroupItemContainerProps {
  isActive: boolean
}
const Delete = styled.div<GroupItemContainerProps>`
  width: 100px;
  height: 22px;
  font-size: 14px;
  margin-right: 10px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  cursor: ${props => (props.isActive ? 'pointer' : 'no-drop')};
  color: ${props => (props.isActive ? '#333' : '#999')};
  justify-content: center;
  transition: 0.3s;
  &:hover {
    background: ${props => (props.isActive ? '#fff' : '#fff')};
    .icon-delete {
      width: 12px;
      stroke: ${props => (props.isActive ? '#f53f3f' : '')};
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`
const Export = styled.div`
  width: 120px;
  height: 24px;
  line-height: 32px;
  font-size: 14px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  cursor: ${props => (props.length > 5 ? 'no-drop' : 'pointer')};
  color: ${props => (props.length > 5 ? '#999' : '#333')};
  justify-content: center;
  transition: 0.3s;
  background: ${props => (props.length > 5 ? '#f5f5f5' : '#f2f3f5')};
  &:hover {
    background-color: #fff;
  }
  .icon-export {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`
const TaskListMain = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  .flex {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .branching {
    width: 1px;
    height: 14px;
    background: #ebebeb;
    margin: 0 14px 0 12px;
  }
  .operate-text {
    color: #4238c9;
    margin-left: 6px;
  }
  .operate-active {
    margin-left: 6px;
  }
  .flex1 {
    flex: 1;
  }
  .flex-end {
    width: 230px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .pointer {
    cursor: pointer;
  }
  /* .ant-dropdown-menu {
    width: 120px;
  } */
`
interface ProgreesProps {
  percent: number
}
const Progress = styled.div<ProgreesProps>`
  width: 100px;
  height: 6px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  position: relative;
  &::before {
    content: '';
    display: inline-block;
    width: ${props => props.percent}%;
    height: 6px;
    background-color: #558492;
    border-radius: 3px;
    position: absolute;
  }
`
const Icon = styled(IconFont)`
  color: #4238c9;
  cursor: pointer;
`
const RefreshButton = styled(Button)`
  border: 0;
  background: #f1f3f8;
  :hover {
    background: #e2e4f6;
  }
`

const Task = styled.div`
  flex-grow: 1;
  //display: flex;
  height: 100%;
  //flex-wrap: wrap;
  //align-content: space-between;
  .ant-dropdown-menu {
    padding: 4px;
  }
  .ant-dropdown-menu-item {
    border-radius: 4px;
    padding: 0;
    /* &:hover {
      color: #4238C9;
      background-color: #e7e9f3;
    } */
  }
  .operate {
    width: 110px;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 5px 12px;
    gap: 8px;
  }
`
